import React from "react";
import data from "../../../package.json";
import { browserName, browserVersion } from "react-device-detect";
import { useReduxUI } from "../../hooks/redux/useReduxUI";
import { Computer } from "../icons";

export const Version = () => {
    const { innerWidth, innerHeight } = window;
    const {
        state: { isOpenMenu, },
        toggledSesionModal
    } = useReduxUI();
    return (
        <section>
            <li
                className={
                    `cursor-pointer list-none flex justify-start items-center gap-2 py-[10px] transition-colors duration-500 rounded-md  
                ${false ? "bg-[#1677FF]" : ""}
                ${!false ? "pl-6" : "pl-4"} ${isOpenMenu ? "" : "lg:justify-center lg:px-6"} 
                `}
            >
                <Computer />
                {isOpenMenu && <span className={`text-white`} onClick={() => {
                    toggledSesionModal(true)

                }}>Cerrar sesión</span>}
            </li>
            <div className="version">
                <span>v-{data.version}</span>
                <span>{browserName} v-{browserVersion}</span>
                <span>
                    {innerWidth} x {innerHeight}
                </span>
            </div>
        </section>

    );
};
